// extracted by mini-css-extract-plugin
module.exports = {"myBookingTicket":"Table_myBookingTicket__2cXqu","myBookingTicketTop":"Table_myBookingTicketTop__eVOs3","myBookingTicketBtm":"Table_myBookingTicketBtm__1KeCl"};